import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  FinancialConcept,
  Period,
} from '../../../models/financial-statement/financial-statement.model';
import { GeneralDTO } from '../../../models/components-general/general-dto.model';
@Injectable({
  providedIn: 'root',
})
export class FinancialStatementService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  public InsertFinancialStatement(financialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(
        `${this.URL_API}/FinancialStatement/InsertFinancialStatement`,
        financialStatement,
      )
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getLastPeriod(financialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(`${this.URL_API}/FinancialStatement/GetLastPeriod`, financialStatement)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public deletePeriod(financialStatement: Period): Observable<GeneralDTO | null> {
    return this.http
      .post<GeneralDTO>(`${this.URL_API}/FinancialStatement/DeletePeriod`, financialStatement)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getHeaderData(finacialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(`${this.URL_API}/FinancialStatement/GetHeaderData`, finacialStatement)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getBodyData(financialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(`${this.URL_API}/FinancialStatement/GetBodyData`, financialStatement)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
  public getCashFlowFinancialStatement(financialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(
        `${this.URL_API}/FinancialStatement/GetcashFlowFinancialStatement`,
        financialStatement,
      )
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
  public updateHeaderData(financialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(`${this.URL_API}/FinancialStatement/UpdateHeaderData`, financialStatement)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
  public updateBodyData(financialConcept: FinancialConcept): Observable<Period | null> {
    return this.http
      .post<Period>(`${this.URL_API}/FinancialStatement/UpdateBodyData`, financialConcept)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public updateAllValues(financialStatement: Period): Observable<Period | null> {
    return this.http
      .post<Period>(`${this.URL_API}/FinancialStatement/UpdateAllValues`, financialStatement)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
